import React from 'react';

interface CardProps {
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export default function Card({ title, children, action, className = '' }: CardProps) {
  return (
    <div className={`mt-8 p-4 bg-white dark:bg-gray-800 rounded-lg shadow ${className}`}>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">{title}</h2>
        {action && action}
      </div>
      {children}
    </div>
  );
}